
const NS = 'ConvertJsonToCsv'; // jshint ignore:line

class ConvertJsonToCsv {
  public downloadCsv(JSONData: any, labels: string[], fileName: string): void {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;

    // Append labels
    let CSV = labels.join(',');

    //1st loop is to extract each row
    arrData.forEach((a: any, i: number) => {
      const values: any[] = [];
      //2nd loop will extract each column and convert it in string comma-seprated
      Object.keys(a).forEach(b => {
        values.push('"' + a[b] + '"');
      })
      //add a line break after each row
      CSV += '\r\n' + values.join(',');
    });

    // Build a link element
    const uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(CSV);
    const link: HTMLAnchorElement  = document.createElement('a');
    link.setAttribute('href', uri);
    link.setAttribute('style', 'visibility:hidden');
    link.setAttribute('download', fileName + '.csv');

    //Append and download the linked report
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

const instance = new ConvertJsonToCsv();
export default instance as ConvertJsonToCsv;
